import ServiceTemplateMobile from "./service-template-mobile";

export default ServiceTemplateMobile;